module.exports = __webpack_public_path__ + "img/1.1fbf60a3.png";